(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-your-look"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.complete-look').forEach(section => {
    const sticky = document.querySelector('sticky-add-to-cart');
    if (!sticky) return;
    const observer = new IntersectionObserver(entries => {
      sticky.toggleAttribute('data-look-shopping', entries[0].isIntersecting);
    });
    observer.observe(section);
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-look-variant]');
    if (!select) return;
    const card = select.closest('.complete-look__card');
    const option = select.selectedOptions[0];
    if (option?.dataset.price) card.querySelector('[data-look-price]').textContent = option.dataset.price;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kapow-community-popup"]) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('.kapow-community').forEach(dialog => {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      const key = 'kapow-community-popup-until';
      const sessionKey = 'kapow-community-popup-start';
      const now = Date.now();
      let start = now;
      let suppressed = false;
      try {
        const savedStart = Number(sessionStorage.getItem(sessionKey));
        if (savedStart > 0) start = savedStart;
        else sessionStorage.setItem(sessionKey, String(now));
        suppressed = Number(localStorage.getItem(key)) > now;
      } catch {}
      const preview = dialog.dataset.draft === 'true' && new URLSearchParams(location.search).get('kapow_popup_preview') === '1';
      const success = Boolean(dialog.querySelector('[data-popup-success]'));
      const error = Boolean(dialog.querySelector('[data-popup-error]'));
      let timer;
      let previousFocus;
      const remember = days => {
        try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch {}
      };
      const close = () => {
        remember(success ? 365 : Number(dialog.dataset.dismissDays) || 7);
        clearTimeout(timer);
        dialog.close();
        if (previousFocus instanceof HTMLElement) previousFocus.focus();
      };
      const open = () => {
        if (dialog.open || !dialog.isConnected) return;
        if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]')) {
          timer = setTimeout(open, 1500);
          return;
        }
        previousFocus = document.activeElement;
        dialog.showModal();
        dialog.querySelector('[data-popup-close]')?.focus();
      };
      dialog.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', close));
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      });
      if (success) remember(365);
      if (preview || success || error) timer = setTimeout(open, 400);
      else if (!suppressed) timer = setTimeout(open, Math.max(0, Number(dialog.dataset.delay) * 1000 - (now - start)));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-looks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const root = document.activeElement?.closest('.shoppable-looks');
    if (!root) return;
    root.querySelectorAll('.shoppable-looks__spot[open]').forEach(spot => {
      spot.open = false;
      spot.querySelector('summary').focus();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
